<div id="about-me" style="position: absolute; top: -0"></div>
<div class="about-content">
  <div class="left">
    <h2>{{ "ABOUT.TITLE" | translate }}</h2>
    <div class="leftTop">
      <p>
        {{ "ABOUT.INTRO1" | translate }}
        <br /><br />
        {{ "ABOUT.INTRO2" | translate }}
        <br /><br />
        {{ "ABOUT.INTRO3" | translate }}
      </p>
    </div>
    <div class="leftBottom">
      <div class="about-me">
        <div class="img">
          <img src="/assets/icons/Location.png" alt="" />
        </div>
        <p>{{ "ABOUT.LOCATION" | translate }}</p>
      </div>
      <div class="about-me">
        <div class="img">
          <img src="/assets/icons/bulb desktop.png" alt="" />
        </div>
        <p>{{ "ABOUT.CURIOSITY" | translate }}</p>
      </div>
      <div class="about-me">
        <div class="img">
          <img src="/assets/icons/puzzle desktop.png" alt="" />
        </div>
        <p>{{ "ABOUT.PROBLEM_SOLVING" | translate }}</p>
      </div>
    </div>
  </div>

  <div class="right">
    <img class="profil-pic" src="/assets/img/profil.png" alt="" />
    <img class="shadow-pic" src="/assets/shadows/shadow-photo.svg" alt="" />
  </div>
</div>
 <img class="vector" src="/assets/shadows/Vector-skills.png" alt="" />
